module.exports = __webpack_public_path__ + "media/icons/menu/logo-1e32d69e09b3bceeca04f5e391ebdcfa.svg";